import { ExperimentTrackingData } from "@rea-argonaut/experiment";
import { GetPageDataArgs } from "./getPageData";
import { getPageData } from "./browserDecorator";
import getUserData from "./getUserData";
import getCampaignData from "./getCampaignData";
import getExperimentsData from "./getExperimentsData";

export type DataGetter = () => Record<string, unknown>;

type GetDefaultViewDataArgs = {
  page: Omit<GetPageDataArgs, "platform" | "responsiveLayout">;
  experiments?: ExperimentTrackingData[];
};

const getDefaultViewData = (
  defaultViewDataOptions: GetDefaultViewDataArgs,
): DataGetter[] => {
  const { page, experiments } = defaultViewDataOptions;
  const defaultViewData = [getPageData(page), getUserData(), getCampaignData()];
  experiments && defaultViewData.push(getExperimentsData(experiments));
  return defaultViewData;
};

export default getDefaultViewData;
